
export interface JsonData {
    page: JsonObject;
}
    
export interface JsonObject {
    pages: Page[][];
    layout?: Layout;
}

export interface Layout {
    pagination?: Pagination;
}

export interface Pagination {
    label?: string;
    current?: number;
    total?: number;
}

export interface Page {
    pageTitle: string;
    content: Content[];
    pageDescription?: string;
    styleClass?: string;
    titleclass?:string;
}

export interface Content {
    id: number;
    type: ContentType;
    text?: string;
    actions?: Action[];
    title?: string;
    titleClass?: string;
    styleClass?: string;
    listStyleClass?: string;
    items?: string[];
    src?: string;
    alt?: string;
    collapsed?: boolean;
    parsedText?: ParsedText[];
    socialIcons?: SocialIcon[];
    articleList?: Article[]; 
    templateBody?: ITemplateBody;
}

export interface ITemplateBody {
    content: Content[];
    styleClass?: string;
    titleClass?: string;
    bodyClass?: string;
}

export interface Article {
    title: string;
    url?: string;
    styleClass?: string;
}
export interface SocialIcon {
    name: string;
    url?: string;
    img?: string;
    styleClass?: string;
}
export interface Action {
    token: string;
    displayText: string;
    actionId: string;
    url: string;
    target: string;
    styleClass: string;
}

export interface ParsedText {
    text?: string;
    isAction?: boolean;
    actionData?: Action;
    styleClass?: string;
}
export enum ContentType {
    TEXT = 'text',
    LIST_SECTION = 'list_section',
    DYNAMIC_TEXT = 'dynamic_text',
    IMAGE = 'image',
    ARTICLE = 'article',
    HR = 'hr',
    TOOLBAR = 'toolbar',
    NG_TEMPLATE="ng_template",
    scrollbar='scroll_bar'
}